import api from "./services/mkm.api.js"

const resource = "/fach"

export default{
    alle() {
        return api.get(`${resource}`);
    },

    allePowerApp() {
        return api.get(`/powerapp${resource}`);
    },

    pruefungsordnung() {
        return api.get(`${resource}/pruefungsordnung`);
    },

    initiativbewerbung() {
        return api.get(`${resource}/initiativbewerbung`);
    }

}